<template>
  <div class="huyi">
    <div style="overflow: hidden">
      <div class="button" style="float:right" v-if="checkDisplay('personButton')">
        <!-- <a-button type="primary" @click="increasePeople">新增人员</a-button> -->
        <a-upload name="files" :customRequest="upload" style="margin-left: 8px">
          <a-button>上传名单</a-button>
        </a-upload>
        <a-button :style="{ marginLeft: '8px' }" @click="downLoad">下载模板</a-button>
      </div>
    </div>
    <div class="table scroll" style="margin-top:10px;">
      <div style class="personList">
        <a-table
          :columns="getColumns"
          :data-source="assitPeople"
          :pagination="false"
          :scroll="{ x: 600 }"
          :rowKey="(record) => record.need_help_person_number_id"
        >
          <span slot="num" slot-scope="text, data, index">{{ index + 1 }}</span>
          <span slot="money" slot-scope="text, data" style="display: inline-block;width:100%">
            <a @click="openInsertMoney(data)" style="display: inline-block;width:100%">
              <span style="display: inline-block;width:100px">{{ text }}</span>
              <a-alert
                message="点此编辑"
                type="info"
                show-icon
                style="display: inline-block;width:90px"
              />
            </a>
          </span>
          <span slot="action" slot-scope="text, data">
            <a @click="deletePeople(data)">删除</a>
            <!--<a-divider type="vertical" />-->
            <!--<a>编辑</a>-->
          </span>
        </a-table>
        <div
          v-if="assitPeople && assitPeople.length > 0 && processConfigType === 'projectFund'"
          style="line-height:34px;background: #fafafa;font-size:14px;color:#151515;position:relative;top:0;left:0;height:32px;"
        >
          <span
            style="display: inline-block;position:absolute;top:0;right:100px;"
            v-if="checkDisplay('personButton')"
          >合计： {{ amount }}</span>
          <span
            v-else
            style="display: inline-block;position:absolute;top:0;right:20px;"
          >合计： {{ amount }}</span>
        </div>
      </div>
      <!-- v-if="processConfigType === 'projectActivity'"   提测暂时 style="display:none" 隐藏 -->
      <a-form :form="form" v-if="processConfigType === 'projectActivity'">
        <div class="bangfurenci">
          <!-- <div class="a-label">总帮扶人次：</div> -->
          <!-- v-decorator="['total_help_count', { rules: [{ required: true, message: '总帮扶人次不能为空' }], initialValue: test }]" -->
          <a-form-item label="总帮扶人次:" :required="true">
            <a-input
              v-if="checkDisplay('personButton')"
              type="text"
              v-decorator="['total_help_count', { initialValue: initData.total_help_count }]"
            />
            <span v-else>{{ initData.total_help_count }}</span>
          </a-form-item>
        </div>
      </a-form>
    </div>

    <SelectPeople
      :visible="selectPeopleVisible"
      :onOk="selectPeople"
      :onCancel="selectCancel"
      title="选择帮扶对象"
      :dataSource="getDataSource"
      :selectedKeys="selectedKeys"
    />
    <a-modal title="帮扶金额" :visible="visible" @cancel="cancel" @ok="handleOk">
      <div class="familyPeople">
        <Form ref="familyPeople" :dataSource="formData" id="familyPeople"></Form>
      </div>
    </a-modal>
    <!-- <a-form-item label="总帮扶人次:" :required="true">
            <a-input type="text" v-decorator="['total_help_count', { initialValue: '1' }]" />
    </a-form-item>-->
  </div>
</template>

<script>
import SelectPeople from '@/components/selectPeople'
import { needHelpPerson, uploadProcessProjectFund } from '@/api/compositeAssit.js'
import Form from '@/components/GlobalForm'

export default {
  name: 'Index',
  props: {
    initData: {
      // 父组件传过来的表单默认值
      type: Object,
      default: () => {
        return {}
      }
    },
    selectAssitPeople: {
      type: Array,
      default: () => {
        return []
      }
    },
    pageType: {
      type: String,
      default: 'launch'
    },
    processStep: {
      type: String,
      default: 'launch'
    },
    checkDisplay: {
      type: Function,
      default: () => { }
    },
    processConfigType: {
      type: String,
      default: ''
    }
  },
  components: {
    SelectPeople,
    Form
  },
  data() {
    return {
      formData: [
        {
          type: 'input',
          label: '帮扶金额',
          col: '24',
          id: 'money',
          onChange: this.numberChange,
          layout: {
            labelCol: '80px'
          }
        }
      ],
      visible: false,
      amount: '0', // 帮扶对象总金额
      columns: [
        {
          title: '序号',
          dataIndex: 'title',
          key: 'title',
          width: '60px',
          fixed: 'left',
          scopedSlots: { customRender: 'num' }
        },
        {
          title: '姓名',
          dataIndex: 'need_help_person_name',
          key: 'need_help_person_name',
          width: '100px',
          ellipsis: true
        },
        {
          title: '身份证号',
          dataIndex: 'need_help_person_number_id',
          key: 'need_help_person_number_id',
          width: '170px',
          ellipsis: true
        },
        {
          title: '户籍地址',
          dataIndex: 'need_help_person_registered_address',
          key: 'need_help_person_registered_address',
          ellipsis: true,
          width: '140px'
        },
        {
          title: '联系电话',
          dataIndex: 'need_help_person_phone_number',
          key: 'need_help_person_phone_number',
          width: '200px',
          ellipsis: true
        },
        {
          title: '区',
          dataIndex: 'district',
          key: 'district',
          width: '140px',
          ellipsis: true
        },
        {
          title: '街镇',
          dataIndex: 'street',
          key: 'street',
          width: '200px',
          ellipsis: true
        },
        {
          title: '家庭类别',
          dataIndex: 'need_help_person_poverty_type',
          key: 'need_help_person_poverty_type',
          ellipsis: true,
          width: '100px'
        },
        {
          title: '帮扶原因',
          dataIndex: 'need_help_person_support_reason',
          key: 'need_help_person_support_reason',
          width: '200px',
          ellipsis: true
        },
        // {
        //   title: '备注',
        //   dataIndex: 'need_help_person_remark',
        //   key: 'need_help_person_remark',
        //   width: '200px',
        //   ellipsis: true
        // },
        {
          title: '帮扶金额',
          width: '220px',
          fixed: 'right',
          dataIndex: 'need_help_assistance_amount',
          key: 'need_help_assistance_amount',
          scopedSlots: { customRender: 'money' },
          ellipsis: true
        },
        {
          title: '操作',
          key: 'action',
          width: '80px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ], // 人员列表头数据,可编辑
      viewColumns: [
        {
          title: '序号',
          dataIndex: 'title',
          key: 'title',
          width: '60px',
          fixed: 'left',
          scopedSlots: { customRender: 'num' }
        },
        {
          title: '姓名',
          dataIndex: 'need_help_person_name',
          key: 'need_help_person_name',
          width: '100px',
          ellipsis: true
        },
        {
          title: '身份证号',
          dataIndex: 'need_help_person_number_id',
          key: 'need_help_person_number_id',
          width: '170px',
          ellipsis: true
        },
        {
          title: '户籍地址',
          dataIndex: 'need_help_person_registered_address',
          key: 'need_help_person_registered_address',
          ellipsis: true,
          width: '140px'
        },
        {
          title: '联系电话',
          dataIndex: 'need_help_person_phone_number',
          key: 'need_help_person_phone_number',
          width: '200px',
          ellipsis: true
        },
        {
          title: '区',
          dataIndex: 'district',
          key: 'district',
          width: '140px',
          ellipsis: true
        },
        {
          title: '街镇',
          dataIndex: 'street',
          key: 'street',
          width: '200px',
          ellipsis: true
        },
        {
          title: '家庭类别',
          dataIndex: 'need_help_person_poverty_type',
          key: 'need_help_person_poverty_type',
          ellipsis: true,
          width: '100px'
        },
        {
          title: '帮扶原因',
          dataIndex: 'need_help_person_support_reason',
          key: 'need_help_person_support_reason',
          width: '200px',
          ellipsis: true
        },
        // {
        //   title: '备注',
        //   dataIndex: 'need_help_person_remark',
        //   key: 'need_help_person_remark',
        //   width: '200px',
        //   ellipsis: true
        // },
        {
          title: '帮扶金额',
          width: '220px',
          fixed: 'right',
          dataIndex: 'need_help_assistance_amount',
          key: 'need_help_assistance_amount',
          ellipsis: true
        }
      ], // 人员列表头数据，只读
      selectPeopleVisible: false, // 选人弹出框
      assitPeople: [], // 已选的帮扶对象
      dataSource: [], // 帮扶对象源数据
      selectedKeys: [], // 已选人员的key集合
      changeId: '',
      form: this.$form.createForm(this, { name: 'coordinated' })
    }
  },
  watch: {
    selectAssitPeople(value) {
      this.assitPeople = value || []
      this.selectedKeys = this.getSelectedKeys(this.assitPeople)
    }
  },
  mounted() {
    this.assitPeople = this.selectAssitPeople || []
    this.selectedKeys = this.getSelectedKeys(this.assitPeople)
  },
  computed: {
    getColumns() {
      // 帮扶对象列表表头
      if (this.pageType === 'approval' && this.processStep === '3') {
        // 服务帮扶 ，没有帮扶金额，删除掉
        if (this.processConfigType === 'projectActivity') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.columns.splice(9, 1)
        }
        return this.columns
      } else {
        if (this.processConfigType === 'projectActivity') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.viewColumns.splice(9, 1)
        }
        return this.viewColumns
      }
    },
    getDataSource() {
      // 数据处理成列表需要展示的
      const data = this._.cloneDeep(this.dataSource)
      for (let i = 0; i < data.length; i++) {
        data[i] = Object.assign({}, data[i], {
          title: data[i].need_help_person_name,
          key: data[i].need_help_person_number_id
        })
      }
      // console.log(data)
      return data
    }
  },
  methods: {
    upload(data) {
      const formData = new FormData()
      formData.append('files', data.file)
      return new Promise((resolve, reject) => {
        uploadProcessProjectFund(formData).then((response) => {
          this.$notification.success({
            message: '文件上传成功'
          })
          this.assitPeople = response
          this.checkAmount(this.assitPeople)
        })
      })
    },
    downLoad(data) {
      // var url = process.env.VUE_APP_API_BASE_URL + '/process/downloadProcessFile?report_file_id=1'
      if (this.processConfigType === 'projectFund') {
        var url = '/zijin_template.xlsx'
      } else {
        // eslint-disable-next-line no-redeclare
        var url = '/fuwu_template.xlsx'
      }
      //  文件下载
      window.open(url)
    },
    numberChange(value) {
      // 只能输入数字校验
      let newValue = value
      newValue = newValue.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
      newValue = newValue.replace(/^\./g, '') // 验证第一个字符是数字而不是.
      newValue = newValue.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的.
      newValue = newValue
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      setTimeout(() => {
        this.$refs.familyPeople.setFieldsValue('money', newValue)
      }, 0)
    },
    // 新增人员t弹出框
    increasePeople() {
      this.selectPeopleVisible = true
      needHelpPerson({}).then((response) => {
        // if (response && response.length > 0) {
        //   this.dataSource = response.map((item) => {
        //     return {
        //       ...item,
        //       need_help_person_number_id: `${item.need_help_person_number_id}`
        //     }
        //   })
        // } else {
        this.dataSource = response || []
        // }
      })
    },
    // 从后台拿到的数据处理一下，默认选中的帮扶对象
    getSelectedKeys(data) {
      this.checkAmount(data) // 计算总金额
      const keys = []
      for (let i = 0; i < data.length; i++) {
        keys.push(data[i].need_help_person_number_id)
      }
      return keys
    },
    // 帮扶对象删除
    deletePeople(data) {
      console.log(data)
      for (let i = 0; i < this.assitPeople.length; i++) {
        // 删除已选列表
        if (this.assitPeople[i].need_help_person_number_id === data.need_help_person_number_id) {
          this.assitPeople.splice(i, 1)
          break
        }
      }
      for (let i = 0; i < this.selectedKeys.length; i++) {
        // 删除已选列表项
        if (this.selectedKeys[i] === data.need_help_person_number_id) {
          this.selectedKeys.splice(i, 1)
          break
        }
      }
      this.checkAmount(this.assitPeople)
    },
    checkAmount(data) {
      let amount = 0
      for (let i = 0; i < data.length; i++) {
        amount = (
          parseFloat(amount || 0) + parseFloat(data[i].need_help_assistance_amount || 0)
        ).toFixed(2)
      }
      this.amount = amount
    },
    // 确认选择人员
    selectPeople(data) {
      let select = []
      // for (let i = 0; i < data.length; i++) {
      //   for (let j = 0; j < this.assitPeople.length; j++) {
      //     if (this.assitPeople[j].need_help_person_number_id === data[i]) {
      //       select.push(this.assitPeople[j])
      //     }
      //   }
      // }
      const newAssitData = this.assitPeople.filter((val) => {
        // 从已选的人员中筛选出和重新选择的人员中一样的数据filter不会改变原来的数组
        for (let i = 0; i < data.length; i++) {
          if (data[i] === val.need_help_person_number_id) {
            return true
          }
        }
        return false
      })
      select = newAssitData
      const newData = data.filter((val) => {
        // 过滤出已选人员中不存在的数据
        for (let i = 0; i < this.assitPeople.length; i++) {
          if (this.assitPeople[i].need_help_person_number_id === val) {
            return false
          }
        }
        return true
      })
      // console.log(newData)
      for (let j = 0; j < newData.length; j++) {
        // 新增数据拿到所有值
        for (let i = 0; i < this.dataSource.length; i++) {
          if (this.dataSource[i].need_help_person_number_id === newData[j]) {
            select.push({ ...this.dataSource[i], need_help_assistance_amount: 0 })
            break
          }
        }
      }
      this.selectedKeys = data
      this.assitPeople = this._.cloneDeep(select)
      this.checkAmount(this.assitPeople)
      // this.assitPeople[this.assitPeople.length - 1] = { need_help_assistance_amount: `合计 ${{ amount }}` }
      this.selectCancel()
    },
    // 选人弹出框关闭
    selectCancel() {
      this.selectPeopleVisible = false
    },
    // 获取已选人员
    getValue() {
      return this.assitPeople
    },
    // 获取帮扶金额和人数
    getMoneyAndRenshu() {
      var bangfujine = 0
      if (this.processConfigType === 'projectFund') {
        this.checkAmount(this.assitPeople)
        bangfujine = this.amount
      }
      return { project_case_support_funds: bangfujine, project_case_support_people: this.assitPeople.length }
    },
    // 帮扶金额弹框
    openInsertMoney(data) {
      // console.log(data)
      this.changeId = data.need_help_person_number_id
      console.log(this.changeId)
      this.visible = true
      const that = this
      setTimeout(() => {
        that.$refs.familyPeople.setFieldsValue('money', data.need_help_assistance_amount)
      }, 10)
    },
    // 帮扶金额弹出框关闭
    cancel() {
      this.$refs.familyPeople.resetFields() // 关闭弹窗时，把组件值置空
      this.visible = false
    },
    // 帮扶金额点击确定
    handleOk() {
      const money = this.$refs.familyPeople.getFieldsValue().money || 0
      for (let i = 0; i < this.assitPeople.length; i++) {
        if (this.changeId === this.assitPeople[i].need_help_person_number_id) {
          this.assitPeople[i].need_help_assistance_amount = parseFloat(money).toFixed(2) // 更新该条信息的金额
          break
        }
      }
      this.checkAmount(this.assitPeople) // 重新计算总金额
      this.cancel() // 关闭弹窗
    },
    // 'total_help_count'
    checkAndTijiao() {
      // alert(JSON.stringify(this.form.getFieldsValue()))
      // return false
      let data = false
      // 是 服务帮扶才要验证
      if (this.processConfigType === 'projectActivity') {
        this.form.validateFields((err, values) => {
          if (!err) {
            // console.log('Received values of form: ', values)
            // eslint-disable-next-line eqeqeq
            if (values.total_help_count != undefined && values.total_help_count != '') {
              data = values
            }
          }
        })
      }
      // 资金帮扶时，直接返回个默认值 projectFund
      if (this.processConfigType === 'projectFund') {
        data = { total_help_count: '' }
      }
      return data
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .ant-upload-list {
  display: none;
}
.table {
  /deep/ .ant-table-thead > tr > th {
    font-size: 14px;
    font-weight: 600;
    padding: 0 16px;
    line-height: 50px;
    color: #1c2d51;
    /*background: #EBF1FB;*/
    /*border:none;*/
  }
  /deep/ .ant-table-tbody > tr > td {
    border: none;
    padding: 0 16px;
    line-height: 34px;
  }
  /deep/ .ant-table-tbody .ant-table-row:nth-child(even) {
    background: #f9fbff;
  }
  /deep/ .ant-table {
    font-size: 14px;
    color: #333;
  }
  /deep/ .ant-table-pagination.ant-pagination {
    float: right;
    margin: 16px;
  }
}
.scroll {
  /deep/ .ant-table-body {
    overflow-x: hidden !important;
  }

  /deep/ .ant-table-body:hover {
    overflow-x: scroll !important;
  }
}
.personList {
  position: relative;
  border: 1px solid #e8e8e8;
  /deep/ .ant-table-wrapper {
    /*border:1px solid #e8e8e8;*/
    border-radius: 2px;
  }
  /deep/ .ant-table-placeholder {
    border-bottom: none;
  }
  /deep/ .ant-alert {
    margin-left: 10px;
    display: inline-block;
    padding: 5px 15px 5px 35px;
    font-size: 12px;
    .ant-alert-icon {
      top: 8px;
    }
  }
  /*/deep/  .ant-table-body {*/
  /*overflow-x: hidden !important;*/
  /*}*/

  /*/deep/  .ant-table-body:hover {*/
  /*overflow-x: scroll !important;*/
  /*}*/
}
.bangfurenci {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  .ant-form-item {
    display: flex;
  }
  .a-label {
    color: black;
    margin-right: 10px;
  }
}
</style>
